import { render, staticRenderFns } from "./add-api.vue?vue&type=template&id=2d37e159&scoped=true"
import script from "./add-api.vue?vue&type=script&lang=js"
export * from "./add-api.vue?vue&type=script&lang=js"
import style0 from "./add-api.vue?vue&type=style&index=0&id=2d37e159&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d37e159",
  null
  
)

export default component.exports